import * as React from 'react';
import IBookmarkListProps from './interfaces/bookmarkListProps';
import IBookmarkState from './interfaces/bookmarkState';
import BookmarkListItem from './bookmarkListItem';
import BookmarkGroup from './bookmarkGroup';
import { connect } from 'react-redux';
import { actionCreators } from './redux/actions';
import { GUID_EMPTY } from '../../common/consts';
import { BookmarkService } from "../../services/bookmarkService"; 

class BookmarkList extends React.Component<IBookmarkListProps, null>  {
    bookmarkService: BookmarkService;
    constructor(props) {
        super(props);
        this.bookmarkService = new BookmarkService();
    }


    componentDidUpdate(prevProps: Readonly<IBookmarkListProps>, prevState: null, snapshot?: any): void {
        if (prevProps.bookmarks !== this.props.bookmarks) {
            this.renderList();
        }
    }

    renderGeneralList() {
        const { categories } = this.props;
        const bookmarkList = [];

        if (!!categories && categories.length > 0) {
            // populate bookmarks based on categories
            categories.forEach((category) => {
                if (category.bookmarks) {
                    category.bookmarks.forEach((bookmark) => {
                        bookmarkList.push({ ...bookmark, categoryName: category.categoryName, categoryId: category.categoryId });
                    });
                }
            });

        } else {
            // if no categories were found, populate them directly
            this.props.bookmarks?.map((bookmark) => {
                bookmarkList.push({ ...bookmark });
            });
        }

        // sorting
        bookmarkList.sort((a, b) => {
            if (a.title && b.title) {
                if (a.title > b.title) {
                    return 1;
                } else {
                    return -1;
                }
            }
            return 0;
        });

        return (
            <ol className="notifications__notifications-list  notifications__notifications-list--new-notices">
                {bookmarkList.map((bookmark, index) => (
                    <BookmarkListItem bookmark={bookmark} key={index}
                        onButtonClick={(event) => { this.props.toggleCategorizeModal(event, bookmark.id, bookmark.title, bookmark.categoryId) }}
                        onLinkClick={() => { this.userPressedBookmark(); }}

                    />
                ))}
            </ol>
        );
    }

    renderByCategoryList() {
        const { categories } = this.props;

        return (
            <ol className="documents">
                {categories && categories.length > 0
                    ? categories
                        .map(c => {
                            const filteredBookmarks = c.bookmarks?.filter(
                                b => b.documentMetaFacetType !== "Utbildning"
                            );
                            return { ...c, filteredBookmarks };
                        })
                        .filter(c => c.categoryName && c.filteredBookmarks?.length > 0)
                        .sort((a, b) => {
                            if (a.categoryName === "Okategoriserat") return 1;
                            if (b.categoryName === "Okategoriserat") return -1;
                            return a.categoryName.localeCompare(b.categoryName);
                        })
                        .map((category, index) => (
                            <BookmarkGroup
                                category={{ ...category, bookmarks: category.filteredBookmarks }}
                                toggleCategorizeModal={this.props.toggleCategorizeModal}
                                key={index}
                            />
                        ))
                    : null
                }
            </ol>
        );
    }

    renderCoursesByCategoryList() {
        const { categories } = this.props;
        return (
            <ol className="courses">
                {categories && categories.length > 0
                    ? categories
                        .map(c => {
                            const filteredBookmarks = c.bookmarks?.filter(
                                b => b.documentMetaFacetType === "Utbildning"
                            );
                            return { ...c, filteredBookmarks };
                        })
                        .filter(c => c.categoryName && c.filteredBookmarks?.length > 0)
                        .sort((a, b) => {
                            if (a.categoryName === "Okategoriserat") return 1;
                            if (b.categoryName === "Okategoriserat") return -1;
                            return a.categoryName.localeCompare(b.categoryName);
                        })
                        .map((category, index) => (
                            <BookmarkGroup
                                category={{ ...category, bookmarks: category.filteredBookmarks }}
                                toggleCategorizeModal={this.props.toggleCategorizeModal}
                                key={index}
                            />
                        ))
                    : null
                }
            </ol>
        );
    }

    renderCategoriesList() {
        const { categories } = this.props;
        const filteredCategories = categories ? categories.filter(x => (x.categoryId !== GUID_EMPTY && x.categoryId !== "-1" )) : null;
        return (
            <React.Fragment>
                <div className="bookmarks__item" onClick={(event) => { this.props.toggleCreateModal(event) }}>
                    <button className="genericBtn primary">Lägg till kategori</button>
                </div>
                <ol className="bookmarks__sublist">
                    {
                        filteredCategories && filteredCategories.map((category, index) => (
                            <li className="bookmarks__item  bookmarks__item--clickable"
                                aria-label={"Redigera " + category.categoryName}
                                key={index}
                                onClick={(event) => { this.props.toggleEditModal(event, category.categoryId) }}
                                tabIndex={0}
                                onKeyUp={(e) => { e.key === 'Enter' && this.props.toggleEditModal && this.props.toggleEditModal(e, category.categoryId) }}
                            >
                                <div className="bookmarks__link  bookmarks__link--heading">{category.categoryName}</div>
                                <div className="bookmarks__edit-button"></div>
                            </li>
                        ))
                    }
                </ol>
            </React.Fragment>
        );
    }

    renderList() {
        const { activeTab } = this.props;
        switch (activeTab) {
            case 'all':
                return this.renderGeneralList();
            case 'edit-categories':
                return this.renderCategoriesList();
            case 'listed-categories':
                return this.renderByCategoryList();
            case 'listed-courses-categories':
                return this.renderCoursesByCategoryList();
        }
    }

    userPressedBookmark() {
        this.bookmarkService.userAccessedBookmark(() => { }, () => { });
    }

    userToggleButtonClick(bookmarkId) {
        this.bookmarkService.userAccessedBookmark(() => { }, () => { });
    }

    render() {
        return this.renderList()
    }
}


const mapDispatchToProps = (dispatch, ownProps): IBookmarkListProps => {
    return {
        ...ownProps,
        setSelectedCategory: (categoryId) => {
            dispatch(actionCreators.setSelectedCategoryId(categoryId))
        },
        addBookmark: (bookmark) => {
            dispatch(actionCreators.addBookmark(bookmark))
        },
        toggleCategorizeModal: (event, bookmarkId, bookmarkName, categoryId) => {
            event.preventDefault();
            if (bookmarkId && bookmarkName && categoryId) {
                dispatch(actionCreators.setSelectedBookmarkId(bookmarkId));
                dispatch(actionCreators.setEditedBookmarkName(bookmarkName));
                dispatch(actionCreators.toggleCategorizeModal());
                dispatch(actionCreators.setSelectedCategoryId(categoryId));
            }
        },
        toggleCreateModal: (event) => {
            event.preventDefault();
            dispatch(actionCreators.toggleCreateModal())
        },
        toggleEditModal: (event, categoryId) => {
            event.preventDefault();
            if (categoryId) {
                dispatch(actionCreators.setSelectedCategoryId(categoryId));
                dispatch(actionCreators.toggleEditModal());
            }
        }
    };
}

const mapStateToProps = (state: IBookmarkState): IBookmarkListProps => {
    return { bookmarks: state.bookmarks, categories: state.categories, activeTab: state.activeTab, selectedCategoryId: state.selectedCategoryId, editedBookmarkName: state.editedBookmarkName };
}

export default connect(mapStateToProps, mapDispatchToProps)(BookmarkList);